export default "/fcbcac1db17390110677298f9d30eeed9c121039/decc719ac0c1523cc2040d71b927dcbc.svg";